import axios from "axios";

// await axios.post("/api/razorpay/create-order-payment", {
//   amount: 500, // ₹500
//   key_id: "dfsf45s5555HHzdf",
//   key_secret: "faHHRSTUYSRST",
// });

export const createOrderPaymentApi = async (payload) => {
  try {
    const response = await axios.post(`/api/razorpay/create-order-payment`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyOrderPaymentApi = async (payload) => {
  try {
    const response = await axios.post(`/api/razorpay/verify-payment`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};